import { render, staticRenderFns } from "./stepA.vue?vue&type=template&id=0356e0b5&scoped=true&"
import script from "./stepA.vue?vue&type=script&lang=js&"
export * from "./stepA.vue?vue&type=script&lang=js&"
import style0 from "./stepA.vue?vue&type=style&index=0&id=0356e0b5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0356e0b5",
  null
  
)

export default component.exports